const OrderWrapper = require('./order-wrapper');
const OrdersNavigation = require('./orders-navigation');
const css = require('./orders.css');

class Orders {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }
}

module.exports = {
    constructor: Orders,
    children: [
        {
            name: 'order-wrapper',
            component: OrderWrapper,
            watcher: {
                currentOrderId: ['account', 'orders', 'currentOrder', 'id'],
                isOrderListInitialized: ['account', 'orders', 'list', 'initialized'],
                showBitrixLeadMapping: ['account', 'orders', 'currentOrder', 'showBitrixLeadMapping']
            }
        },
        {
            name: 'orders-navigation',
            component: OrdersNavigation,
            watcher: {
                isManager: ['user', 'isManager'],
                isError: ['account', 'orders', 'list', 'isError']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/orders/index.js